export const getSafeChargeEnv = () => process.env.REACT_APP_API_ENV === 'production' ? 'prod' : 'int';

export const getGpayEnv = () => process.env.REACT_APP_API_ENV === 'production' ? 'PRODUCTION' : 'TEST';
